// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import CharacterLockSvg from '@rsuite/icon-font/lib/people/CharacterLock';
var CharacterLock = createSvgIcon({
  as: CharacterLockSvg,
  ariaLabel: 'character lock',
  category: 'people',
  displayName: 'CharacterLock'
});
export default CharacterLock;